module.exports = __webpack_public_path__ + "static/media/15.ff5e5c2f.jpg";